// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoginView-container {
  margin-top: 6rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.LoginView-heading {
  color: #1e1e1e;
  font-family: Syne;
  font-size: 24px;
  font-weight: 700;
  line-height: 29px;
  letter-spacing: 0.02em;
}
.LoginView-line {
  color: #333333;
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  letter-spacing: 0em;
  display: flex;
}
.LoginView-line img {
  margin-left: 2px;
}
.LoginView-warning {
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  align-items: center;
}
.LoginView-resend {
  font-family: Outfit;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  color: #00aa74;
}
.LoginView-msg {
  font-size: 14px;
  font-weight: 300;
  line-height: 18px;
  letter-spacing: 0em;
  color: #ec6a5e;
}
.LoginView-warningMsg {
  display: flex;
  gap: 5px;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/Views/beforeAuth/LoginView/LoginView.scss","webpack://./src/Styles/sass/_variables.scss"],"names":[],"mappings":"AAGI;EACI,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAFR;AAII;EACI,cCUU;EDTV,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAFR;AAII;EACI,cCGU;EDFV,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;AAFR;AAIQ;EACI,gBAAA;AAFZ;AAKI;EACI,aAAA;EACA,8BAAA;EACA,cAAA;EACA,mBAAA;AAHR;AAKI;EACI,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAHR;AAKI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAHR;AAKI;EACI,aAAA;EACA,QAAA;EACA,mBAAA;AAHR","sourcesContent":["@import '../../../Styles/sass/variables';\n\n.LoginView {\n    &-container {\n        margin-top: 6rem;\n        padding: 2rem;\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n    }\n    &-heading {\n        color: $color_black_300;\n        font-family: Syne;\n        font-size: 24px;\n        font-weight: 700;\n        line-height: 29px;\n        letter-spacing: 0.02em;\n    }\n    &-line {\n        color: $color_black_200;\n        font-size: 14px;\n        font-weight: 300;\n        line-height: 18px;\n        letter-spacing: 0em;\n        display: flex;\n        // align-items: center;\n        img{\n            margin-left: 2px;\n        }\n    }\n    &-warning {\n        display: flex;\n        justify-content: space-between;\n        margin: 10px 0;\n        align-items: center;\n    }\n    &-resend {\n        font-family: Outfit;\n        font-size: 14px;\n        font-weight: 500;\n        line-height: 18px;\n        letter-spacing: 0em;\n        color: #00aa74;\n    }\n    &-msg {\n        font-size: 14px;\n        font-weight: 300;\n        line-height: 18px;\n        letter-spacing: 0em;\n        color: #ec6a5e;\n    }\n    &-warningMsg {\n        display: flex;\n        gap: 5px;\n        align-items: center;\n    }\n}\n","//Primary shades\n$primary_green: #00aa74;\n$primary_light: #e6f7ef;\n$primary_gradient: linear-gradient(109.42deg, #00aa74 0%, #16eba6 100%, #16eba6 100%);\n$primary_gradient1: linear-gradient(108deg, #00AA74 -78.7%, #1E1E1E 59.58%);\n\n//secondary shades\n$secondary_dark: #012515;\n\n//semantic\n$semantic_red: #ec6a5e;\n$semantic_orange: #dfa102;\n\n//Grey Shades\n$color_grey_400: #8c8c8c;\n$color_grey_300: #b3b3b3;\n$color_grey_200: #d9d9d9;\n$color_grey_100: #f2f2f2;\n\n//Black Shades\n$color_black_400: #000000;\n$color_black_300: #1e1e1e;\n$color_black_200: #333333;\n$color_black_100: #4c4c4c;\n\n//green shades\n$color_green_100: #e6f7ef;\n$color_green_150: #c2ead8;\n$color_green_200: #9adcbf;\n$color_green_300: #6ecfa6;\n$color_green_400: #48c493;\n$color_green_500: #09ba80;\n$color_green_600: #009766;\n$color_green_700: #00865a;\n$color_green_800: #006643;\n\n//Fontstyles\n$main_font: 'Syne', sans-serif;\n$secondary_font: 'Outfit', sans-serif;\n$tertiary_font: 'Space Grotesk', sans-serif;\n$text_size: 1rem;\n$dashboardtext: #575757;\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
